import { AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosConfig } from "./axiosConfig";

export interface ApiError {
  message: string;
  status: number;
  errors?: any;
}

export interface RequestConfig extends AxiosRequestConfig {
  showNotification?: boolean;
  customErrorMessage?: string;
  /** When true, global error toasts are suppressed for this request */
  silent?: boolean;
}

export const get = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await axiosConfig.get(url, config);
  return response.data;
};

export const post = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await axiosConfig.post(url, data, config);
  return response.data;
};

export const put = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await axiosConfig.put(url, data, config);
  return response.data;
};

export const patch = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await axiosConfig.patch(url, data, config);
  return response.data;
};

export const del = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await axiosConfig.delete(url, config);
  return response.data;
};
